<template>
    <div>
        <div class="row" style="margin-left: 20px" >
            <div class="col-md-2" :style="'border-style: solid; border-color: '+status.color" v-for="status in statuses" >
                <button
                    :data-id="status.id"
                    class="btn btn-xs shortcut-tiles"
                    :style="'width: 350px; cursor:pointer; background: transparent !important; margin-left:2px; color:'+status.color"
                    type="button"
                    @click="nextState(status.id)">
                    <div style="background:#1767a2 !important" class="tiles-body"></div>
                    <div style="background:#1767a2 !important; padding-top:0;" class="tiles-footer">
                        <div style="font-size:18px; text-align:center"><i :class="'fas '+status.icon"></i></div>
                        <div style="text-align: center;padding:auto;">{{status.name}}</div>
                    </div>
                </button>
            </div>
        </div>
        <input type="hidden" name="tabChart[nextStatus]" v-model="this.nextStatus">
    </div>
    <!-- var datas = {id_scheda: ID_SCHEDA, id_stato: NEW_STATO,id_gruppo_val:'<?= $id_gruppo_valutazione?>'}; -->
</template>

<script>

    export default {
        mounted(){

        },
        data () {
            return {
                nextStatus : ''
            }
        },
        methods:{
            nextState(id){

                if (!checkAllRequired()){
                    return false;
                }

                Vue.swal.fire({
                    title: 'Are you sure?',
                    text: "You want step up the chart to next status? If you forgot to fill out some required field, the operation will stop",
                    icon: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok'
                    }).then((result) => {
                        if (result.value) {


                            let promise = new Promise((resolve, reject) => {
                                this.nextStatus = id;
                                resolve(this.nextStatus," Success!"); // È andato tutto perfettamente!
                            });

                            promise.then((successMessage) => {
                                // successMessage viene passato alla funzione resolve(...) .
                                // Non deve essere necessariamente una stringa, ma nel caso sia solo un messaggio probabilmemte lo sarà.
                                console.log("Yay! " + successMessage);
                                document.getElementById("questionAnswersForm").submit();
                            });
                        }
                });
            }
        },
        props:{
            chart_id        : String,
            statuses        : Object,
            urlTo           : String,
            currentStatus   : String,
        }
    }
</script>
